import React, { useEffect, useRef, useState } from 'react'
import ace from 'brace'
import { JsonEditor as Editor } from 'jsoneditor-react'
import './json-viewer.css'

import '@contentful/forma-36-react-components/dist/styles.css'
import 'jsoneditor-react/es/editor.min.css'
import 'brace/mode/json'
import 'brace/theme/github'

const JSONViewer = ({ data }: { data: any }) => {

  const editorRef = useRef(null) as any

  const [copyText, setCopyText] = useState('copy')

  useEffect(() => {
    if (editorRef.current !== null) {
      editorRef.current.expandAll()
    }
  }, [data])

  const copyToClipboard = async () => {
    if (window.isSecureContext) {
      await navigator.clipboard.writeText(JSON.stringify(data))
      setCopyText('Copied!!!')
      setTimeout(() => setCopyText('Copy'), 2000)
    }
  }

  return (
    <>
      <div className="position-relative">
        <div className="copy-btn-container mt-3">
          <button onClick={copyToClipboard} type='button' className='cursor-pointer border-0 text-capitalize text-white font-14 weight-400'>{copyText}</button>
        </div>
      </div>
      <Editor
        mode="view"
        history
        navigationBar={false}
        statusBar={false}
        value={data}
        ref={editorRef}
        onChange={() => null}
        ace={ace}
        theme="ace/theme/github"
        schema=''
      />
    </>
  )
}

export default JSONViewer
